import React, { useState, useEffect, memo } from "react";
import {
  Button,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Spinner,
  FormGroup,
  Input,
  Label
 
} from "reactstrap";

import { MdClose } from "react-icons/md";
import "./locationInput.scss";
import { withFormsy } from "formsy-react";

const LocationInput = memo(props => {
  const { setValue, formState, isView, viewState } = props;
  const [locations, setLocations] = useState([]);
  const [localAddress, setLocInput] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  //set the location add button to it's default state.
  const [disabledButton, setLocationButton] = useState(true);
  //validate latitude and longitude
  const [latError, setLatError] = useState(false);
  const [longError, setLongError] = useState(false);
  const cordinateRegex = /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/;
  const handleLocInput = e => {
    e.preventDefault();
    if (e.target.id === "minilocationAddress") {
      setLocInput(e.target.value);
    }
    if (e.target.id === "latitude") {
      setLatitude(e.target.value);
    }
    if (e.target.id === "longitude") {
      setLongitude(e.target.value);
      let isValidLongitudeOnChange = cordinateRegex.test(e.target.value);
      setLocationButton(!isValidLongitudeOnChange);
    }
  };


  useEffect(() => {
    if (formState && formState.submitted) {
      setLocations([]);
      setLocInput("");
      setLatitude("");
      setLongitude("");
      setValue([]);
    }
    return () => {
      setLocations([]);
      setLocInput("");
      setLatitude("");
      setLongitude("");
    };
  }, [formState]);

  useEffect(() => {
    if (
      viewState &&
      viewState.response &&
      viewState.response.data &&
      viewState.response.data.length &&
      !viewState.loading &&
      viewState.fetched
    ) {
      setLocations(viewState.response.data);
      setValue(viewState.response.data);
    }
  }, [viewState]);

  useEffect(() => {
    if (longitude !== "") {
      let isValidLongitude = cordinateRegex.test(longitude);
      setLongError(!isValidLongitude);
    }
    if (longitude !== "" && latitude !== "" && localAddress !== "") {
      if (!cordinateRegex.test(longitude) || !cordinateRegex.test(latitude)) {
        setLocationButton(true);
      } else {
        setLocationButton(false);
      }
    }
 
  }, [longitude]);
  useEffect(() => {
    if (latitude !== "") {
      let isValidLatitude = cordinateRegex.test(latitude);
      setLatError(!isValidLatitude);
      if (!cordinateRegex.test(longitude) || !cordinateRegex.test(latitude)) {
        setLocationButton(true);
      } else {
        setLocationButton(false);
      }
    }
  

    //check if any field is empty..
    if (localAddress === "" || latitude === "" || longitude === "") {
      setLocationButton(true);
      if (latitude === "") {
        setLatError(false);
      }
    
    }
   
  }, [localAddress, latitude]);

  const addNewLocation = () => {
    if (localAddress !== "" && latitude !== "" && longitude !== "") {
      const locationObject = {
        address: localAddress,
        lat: latitude,
        lng: longitude
      };
      const newLocationArray = [...locations, locationObject];
      setLocations(newLocationArray);
      setValue(newLocationArray);
      setLocInput("");
      setLatitude("");
      setLongitude("");
    }

  };

  const removeLocation = selectedLocation => {
    const filteredLocations = locations.filter(
      location => locations.indexOf(location) !== selectedLocation
    );
    setLocations(filteredLocations);
    setValue(filteredLocations);
  };

  return (
    <Card className="mb-4">
      <CardHeader>Locations</CardHeader>
      <CardBody className="px-3 py-2">
        {formState.loading && (
          <Alert color="info">
            <Spinner size="sm" /> Updating locations
          </Alert>
        )}
        {formState.error && (
          <Alert color="danger">{formState.error.message}</Alert>
        )}
        {viewState.error && (
          <Alert color="danger">{viewState.error.message}</Alert>
        )}
        {!!isView ? null : (
          <Row>
         
            <FormGroup>
              <Col sm="12" /*className="pr-0"*/>
                <a
                  href="https://www.latlong.net/"
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{
                    color: "blue",
                    fontStyle: "italic",
                    fontSize: "10px"
                  }}
                >
                  Click here to get your address latitude and longitude.
                </a>
                <Input
                  type="text"
                  name="minilocationAddress"
                  id="minilocationAddress"
                  placeholder="Enter Address"
                  value={localAddress}
                  onChange={handleLocInput}
                  size="40"
                />

                <Row>
                  <Col sm="6">
                    <Label>
                      Latitude<span style={{ color: "red" }}>*</span>{" "}
                    </Label>
                    <Input
                      type="text"
                      name="latitude"
                      id="latitude"
                      value={latitude}
                      onChange={handleLocInput}
                      size="1"
                      style={{ borderColor: latError ? "red" : null }}
                    />
                  </Col>
                  <Col sm="6">
                    <Label>
                      Longitude<span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="text"
                      name="longitude"
                      id="longitude"
                      value={longitude}
                      onChange={handleLocInput}
                      size="1"
                      style={{ borderColor: longError ? "red" : null }}
                    />
                  </Col>
                </Row>
            
              </Col>
           
              <Col>
                <Button
                  type="button"
                  color="secondary"
                  disabled={disabledButton} 
                  onClick={addNewLocation}
                  style={{ marginTop: "0.5rem" }}
                >
                  Add
                </Button>
              </Col>
            </FormGroup>
       
          </Row>
        )}

        {viewState.loading ? (
          <div className="text-center pt-4">
            <Spinner />
          </div>
        ) : (
          <div>
            {locations.map((location, key) => (
              <Card key={key}>
                <div >
                  {!isView && (
                    <MdClose
                      className="remove-icon"
                      onClick={() => removeLocation(key)}
                      style={{ marginLeft: "13rem" }}
                    />
                  )}
                  <p
                    key={key + 1}
                    style={{
                      fontSize: "8pt",
                      marginBottom: "0rem",
                      marginLeft: "2pt"
                    }}
                  >
                    Add:{location.address}
                  </p>{" "}
                  <span
                    key={key + 2}
                    style={{
                      fontSize: "8pt",
                      marginBottom: "0rem",
                      marginLeft: "2pt"
                    }}
                    className="mr-5"
                  >
                    Lat: {location.lat}{" "}
                  </span>{" "}
                  <span
                    key={key + 3}
                    style={{ fontSize: "8pt", marginBottom: "0rem" }}
                  >
                    Lng: {location.lng}{" "}
                  </span>{" "}
                </div>
              </Card>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  );
});

export default withFormsy(LocationInput);
